import React, { Component } from 'react';
import classNames from 'classnames';
import FJUtil from '../../../util/FJUtil';
import styles from './FJValueInput.module.less';

class FJValueInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputValue: props.value,
            isFocus: false,
            temporaryUpdate: false,
        };
    }

    focus = () => {
        this._onFocus();
    };

    componentDidMount() {
        this.input.addEventListener('dragstart', e => {
            e.preventDefault();
        });
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if ((!isNaN(nextProps.value) || this.props.useInTime) && nextProps.value !== this.props.value) {
            this.setState({ inputValue: nextProps.value });
        }
    }

    updateValue(value, temporaryUpdate) {
        this.setState({ inputValue: value, temporaryUpdate: temporaryUpdate });
    }

    render() {
        let { inputValue, isFocus, temporaryUpdate } = this.state;
        let { hasUnit, unit, width, height, value, className, inputClassName, onClick = () => {} } = this.props;
        let cn = classNames(styles.value_input, { focus: isFocus }, className);

        // 输入框获取焦点时使用state的数据，反之使用props的数据
        inputValue = isFocus || temporaryUpdate ? inputValue : value;
        let useInputValue = isFocus ? inputValue : hasUnit ? inputValue + unit : inputValue;
        useInputValue = inputValue === '' && !isFocus ? '- -' : useInputValue;
        return (
            <div className={cn} style={{ width, height }} onClick={onClick}>
                <input
                    ref={ele => (this.input = ele)}
                    value={useInputValue}
                    onBlur={this._enterInput}
                    onFocus={this._onFocus}
                    onChange={this._changeInput}
                    onKeyDown={this._inputKeyDown}
                    onDragStart={this._dragStart}
                    style={{ opacity: inputValue === '' && !isFocus ? '0.4' : 1 }}
                    className={inputClassName}
                />
            </div>
        );
    }

    /**
     * @description 根据传进来的最大最小值确定极限值
     * @param value
     * @returns {*}
     * @private
     */
    _getLimitValue = value => {
        if (value > this.props.max) {
            value = this.props.max;
        }
        if (value < this.props.min) {
            value = this.props.min;
        }
        return value;
    };

    /**
     * 输入框按键
     * @param e
     * @private
     */
    _inputKeyDown = e => {
        if (this.props.disabled) return;

        if (e.keyCode === 13) {
            this.input.blur();
        }
    };

    /**
     * 确认输入的值
     * @param e
     * @private
     */
    _enterInput = e => {
        if (this.props.disabled) return;

        this.setState({ isFocus: false });
        let value = e.target.value;

        if (value.replace(/ /g, '') === '') {
            value = this.props.value;
            return;
        }

        if (this.props.useInTime) {
            if (!this.props.isUseInSubtitle) {
                window.addStatisticalEvent('storyboard time input', { value: value });
            }

            value = FJUtil.parseTimeInput(value);
            if (value === undefined) return;
            // 此处的取极限应放在值对比之前，位置不可变
            value = this._getLimitValue(value);

            // 校验完成后 将最终输入的结果 转化为标准时间格式，与 上次输入的结果进行比较，相同则不提交（如用户两次输入了 相同或不同格式下的 同等时间，则不提交）
            if (this.props.getTimeBySecond(value) === this.props.value) {
                this.setState({ inputValue: this.props.value });
                return;
            }
        } else {
            const { digits = 0 } = this.props;
            let matches;
            if (digits === 0) {
                matches = /^(-?)0*(0|\d+)$/.exec(value);
            } else if (digits === 1) {
                // matches = /([1-9]\d*|0)+(\.\d{0,1})?/.exec(value);
                matches = /^(-?)0*(0|\d+)$/.exec(value * 10);
            } else if (typeof digits === 'number' && digits > 1) {
                matches = /^(-?)0*(0|\d+)$/.exec(value * Math.pow(10, digits));
            }
            if (!matches) {
                matches = /^(-?)\d*(.\d+)$/.exec(value);
                if (!matches) {
                    this.setState({ inputValue: this.props.value });
                    return;
                } else {
                    if (digits === 0) value = parseInt(matches[0]);
                    else if (digits === 1) value = parseInt(matches[0] * 10) / 10;

                    if (isNaN(value)) {
                        value = this.props.value;
                    }
                }
            } else {
                if (digits === 0) {
                    value = parseInt(matches[1] + matches[2]);
                } else if (digits === 1) {
                    value = parseInt(matches[1] + matches[2]);
                    value = value / 10;
                } else if (typeof digits === 'number' && digits > 1) {
                    value = parseInt(matches[1] + matches[2]);
                    value = value / Math.pow(10, digits);
                }
            }
            value = this._getLimitValue(value);
        }

        if (this.props.changeValue) {
            this.props.changeValue(value);
        }
    };

    /**
     * 输入框内容改变
     * @param e
     * @private
     */
    _changeInput = e => {
        if (this.props.disabled) return;

        let value = e.target.value;
        this.setState({ inputValue: value });
    };

    _onFocus = e => {
        // 字幕特殊处理 获取焦点后自动进行部分选中，如果点击区域在MM 则选中mm，如果在ss 则选中ss。如果在ms则选中ms。后续操作不做特殊处理。
        const __selectInput = () => {
            const currentSelectionStart = e.target.selectionStart;
            let selectionStart = 0;
            let selectionEnd = 0;
            if (currentSelectionStart >= 0 && currentSelectionStart <= 2) {
                selectionStart = 0;
                selectionEnd = 2;
            } else if (currentSelectionStart >= 3 && currentSelectionStart <= 5) {
                selectionStart = 3;
                selectionEnd = 5;
            } else {
                selectionStart = 6;
                selectionEnd = 7;
            }
            this.input.selectionStart = selectionStart;
            this.input.selectionEnd = selectionEnd;
        };

        // 火狐浏览器兼容处理
        const browser = FJUtil.getBrowser();
        if (browser === 'FF' && this.props.isUseInSubtitle) {
            __selectInput();
        }

        if (this.props.disabled) return;
        // 获取焦点时需应将props的value值赋给state的value值
        this.setState({ isFocus: true, inputValue: this.props.value }, () => {
            if (browser === 'Safari') {
                this.input.value = '';
                this.input.value = this.state.inputValue;
            }

            // safari下可能会被其他事件影响
            setTimeout(() => {
                if (this.props.isUseInSubtitle) {
                    if (browser !== 'FF') {
                        __selectInput();
                    }
                } else {
                    this.input.select();
                }
            }, 0);
        });
    };
}

export default FJValueInput;
